import React from 'react';
import { Check, X } from 'lucide-react';

const Comparison = () => {
  const features = [
    { feature: 'Design Exclusivo e Profissional', system: true, others: false },
    { feature: 'Código Otimizado e Limpo', system: true, others: false },
    { feature: 'SEO Avançado Integrado', system: true, others: 'Básico' },
    { feature: 'Responsivo para Todos Dispositivos', system: true, others: true },
    { feature: 'Velocidade de Carregamento', system: 'Instantâneo', others: 'Lento' },
    { feature: 'Suporte Técnico', system: '24/7', others: 'Limitado' },
    { feature: 'Garantia de Satisfação', system: '100%', others: 'Nenhuma' },
    { feature: 'Manutenção Inclusa', system: 'Disponível', others: 'Extra' },
    { feature: 'Segurança SSL', system: true, others: 'Extra' },
    { feature: 'Painel Administrativo', system: true, others: false },
    { feature: 'Integrações Personalizadas', system: true, others: 'Limitado' },
    { feature: 'Tempo de Entrega', system: '48-72h', others: '2-4 semanas' }
  ];

  const renderValue = (value) => {
    if (value === true) {
      return <Check size={24} color="#D4AF37" />;
    }
    if (value === false) {
      return <X size={24} color="#666666" />;
    }
    return (
      <span style={{
        fontFamily: 'Montserrat, sans-serif',
        fontSize: '14px',
        fontWeight: '600',
        color: typeof value === 'string' && value.includes('Instant') || value.includes('24/7') || value.includes('100%') ? '#D4AF37' : '#CCCCCC'
      }}>
        {value}
      </span>
    );
  };

  return (
    <section style={{
      padding: '120px 40px',
      background: '#000000'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div className="fade-in" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title">
            Por Que Escolher a <span className="gold-gradient">System</span>?
          </h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Compare e veja por que somos a escolha certa para empreendedores que buscam
            excelência e resultados reais.
          </p>
        </div>

        <div className="fade-in" style={{
          background: 'linear-gradient(145deg, rgba(10, 10, 10, 0.8) 0%, rgba(0, 0, 0, 0.9) 100%)',
          border: '2px solid rgba(212, 175, 55, 0.3)',
          borderRadius: '16px',
          overflow: 'hidden',
          transitionDelay: '0.2s'
        }}>
          {/* Table Header */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr',
            gap: '20px',
            padding: '30px 40px',
            background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15) 0%, transparent 100%)',
            borderBottom: '1px solid rgba(212, 175, 55, 0.3)'
          }}>
            <div style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '20px',
              fontWeight: '700',
              color: '#FFFFFF'
            }}>
              Características
            </div>
            <div style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '20px',
              fontWeight: '700',
              color: '#D4AF37',
              textAlign: 'center'
            }}>
              SYSTEM
            </div>
            <div style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '16px',
              fontWeight: '600',
              color: '#666666',
              textAlign: 'center'
            }}>
              Concorrentes
            </div>
          </div>

          {/* Table Body */}
          {features.map((item, idx) => (
            <div
              key={idx}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr',
                gap: '20px',
                padding: '25px 40px',
                borderBottom: idx < features.length - 1 ? '1px solid rgba(212, 175, 55, 0.1)' : 'none',
                transition: 'background 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <div style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px',
                fontWeight: '400',
                color: '#FFFFFF'
              }}>
                {item.feature}
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                {renderValue(item.system)}
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                {renderValue(item.others)}
              </div>
            </div>
          ))}
        </div>

        {/* Urgency banner */}
        <div className="fade-in" style={{
          marginTop: '60px',
          textAlign: 'center',
          padding: '40px',
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, rgba(212, 175, 55, 0.05) 100%)',
          border: '2px solid #D4AF37',
          borderRadius: '12px',
          position: 'relative',
          overflow: 'hidden',
          transitionDelay: '0.4s'
        }}>
          <div style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: '#D4AF37',
            color: '#000000',
            padding: '8px 20px',
            borderRadius: '20px',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '12px',
            fontWeight: '700',
            letterSpacing: '1px',
            animation: 'pulse 2s infinite'
          }}>
            VAGAS LIMITADAS
          </div>
          <h3 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '32px',
            fontWeight: '700',
            marginBottom: '15px',
            color: '#FFFFFF'
          }}>
            Apenas <span style={{ color: '#D4AF37' }}>3 Vagas</span> Disponíveis Este Mês
          </h3>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '16px',
            fontWeight: '300',
            color: '#CCCCCC',
            marginBottom: '30px'
          }}>
            Para garantir a qualidade premium que nossos clientes merecem, aceitamos
            um número limitado de projetos por mês.
          </p>
          <button
            onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Quero garantir minha vaga ainda este mês!', '_blank')}
            className="btn-primary shimmer"
            style={{ fontSize: '18px' }}
          >
            GARANTIR MINHA VAGA AGORA
          </button>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
        @media (max-width: 768px) {
          .comparison-table {
            font-size: 12px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Comparison;